export default __webpack_public_path__ + "static/media/card2-ecom.637829f6.jpg";